import LoadingEmptyError from "components/LoaderEmptyErrorState";
import withLoader from "hoc/loader";
import React from "react";

import AppCardItem from "./AppCard";
import { AppsWidgetProps } from "./interface";
import { GridWrapper } from "./styled.components";

const Apps = ({ apps, isError, isFetching }: AppsWidgetProps) => {
  const isEmpty = !apps || apps.length === 0;

  if (isError || isFetching || isEmpty) {
    return (
      <LoadingEmptyError
        isEmpty={isEmpty}
        isError={isError}
        isLoading={isFetching}
        largesize={true}
      />
    );
  }

  return (
    <GridWrapper>
      {apps.map((app) => (
        <AppCardItem key={app.id} app={app} />
      ))}
    </GridWrapper>
  );
};

const PURE = React.memo(withLoader(Apps));
export default PURE;
